import type {
    EccoAddBillingAddressToMyCartMutationVariables,
    EccoAddDeliveryAddressToMyCartMutationVariables,
    EccoAddDeliveryDateAndTimeSlotToCartMutationVariables,
    EccoAddShippingMethodToCartMutationVariables,
    EccoUpdateLineItemSupplyChannelMutation,
    EccoUpdateLineItemSupplyChannelMutationVariables,
} from "@graphql/generated/types";
import { updateMutation } from "../helpers";
import { useStore } from "../store";
import { useCommerceClient } from "@graphql/useCommerceClient";

const useCartStore = () => {
    const setCartData = useStore((state) => state.setCart);
    return { setCartData };
};

export const useUpdateBillingAddress = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.eccoAddBillingAddressToMyCart;
    const { setCartData } = useCartStore();
    return updateMutation<EccoAddBillingAddressToMyCartMutationVariables>(
        executeWithVariables,
        setCartData
    );
};

export const useUpdateDeliveryAddress = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.eccoAddDeliveryAddressToMyCart;
    const { setCartData } = useCartStore();
    return updateMutation<EccoAddDeliveryAddressToMyCartMutationVariables>(
        executeWithVariables,
        setCartData
    );
};

export const useUpdateDeliveryDateAndTimeSlot = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.eccoAddDeliveryDateAndTimeSlotToCart;
    const { setCartData } = useCartStore();
    return updateMutation<EccoAddDeliveryDateAndTimeSlotToCartMutationVariables>(
        executeWithVariables,
        setCartData
    );
};

export const useAddShippingMethodToCart = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.eccoAddShippingMethodToCart;
    const { setCartData } = useCartStore();
    return updateMutation<EccoAddShippingMethodToCartMutationVariables>(
        executeWithVariables,
        setCartData
    );
};

export const useUpdateLineItemSupplyChannel = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.eccoUpdateLineItemSupplyChannel;
    const { setCartData } = useCartStore();
    return updateMutation<
        EccoUpdateLineItemSupplyChannelMutationVariables,
        EccoUpdateLineItemSupplyChannelMutation
    >(executeWithVariables, setCartData);
};
